import { render, staticRenderFns } from "./UpsertPrintBackgroundTemplate.vue?vue&type=template&id=2ff57286&scoped=true"
import script from "./UpsertPrintBackgroundTemplate.vue?vue&type=script&lang=ts"
export * from "./UpsertPrintBackgroundTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff57286",
  null
  
)

export default component.exports